/* Правила доставки. Скидка теперь приходит с бэка через cart-промо. */

export const DELIVERY_ZONES = [
    { id: 'msk', label: 'Москва и Московская область', freeFrom: 10000, fee: 350, eta: '1–2 дня' },
    { id: 'center', label: 'Центральный округ (кроме Москвы и МО)', freeFrom: 15000, fee: 450, eta: '2–4 дня' },
    { id: 'ru', label: 'Другие округа России', freeFrom: 25000, fee: 550, eta: '3–7 дней' },
];

export function zoneById(id) {
    return DELIVERY_ZONES.find((z) => z.id === id) || DELIVERY_ZONES[2];
}

/* Проверка применимости cart-акции */
function isCartPromoApplicable(promo, cartLines, subtotalRub) {
    if (promo.type === 'cart_total') {
        return subtotalRub >= (promo.min_amount || 0);
    }
    if (promo.type === 'cart_quantity') {
        const distinct = new Set(cartLines.map((l) => String(l.id))).size;
        return distinct >= (promo.min_quantity || 0);
    }
    return false;
}

/* Выбирает лучшую cart-акцию и считает скидку поштучно */
export function applyBestCartPromo(cartLines, cartPromos, subtotalRub) {
    if (!cartPromos?.length || !cartLines?.length) return null;

    const applicable = cartPromos.filter((p) => isCartPromoApplicable(p, cartLines, subtotalRub));
    if (!applicable.length) return null;

    // Сортируем по приоритету
    applicable.sort((a, b) => (b.priority || 0) - (a.priority || 0));
    const best = applicable[0];

    // Считаем скидку поштучно (в рублях для простоты)
    let discountRub = 0;
    cartLines.forEach((l) => {
        const unit = Number(l.price) || 0;
        const qty = Number(l.qty) || 1;
        if (best.discount_type === 'percent') {
            const pct = Math.min(best.discount_value, 25);
            discountRub += Math.round(unit * pct / 100 * 100) / 100 * qty;
        } else if (best.discount_type === 'fixed') {
            discountRub += Math.min(unit, best.discount_value) * qty;
        }
    });

    return {
        promo: best,
        discountRub: Math.round(discountRub * 100) / 100,
    };
}

/* Универсальный расчёт корзины */
export function calcTotals(cart, zoneId, cartPromos = []) {
    const zone = zoneById(zoneId);
    const lines = cart || [];

    const subtotalRub = lines.reduce(
        (sum, l) => sum + (Number(l.price) || 0) * (Number(l.qty) || 1),
        0
    );

    const applied = applyBestCartPromo(lines, cartPromos, subtotalRub);
    const discountRub = applied ? applied.discountRub : 0;
    const deliveryRub = subtotalRub >= zone.freeFrom ? 0 : zone.fee;
    const totalRub = subtotalRub - discountRub + deliveryRub;

    return {
        zone,
        subtotalRub,
        discountRub,
        deliveryRub,
        totalRub,
        appliedPromo: applied ? applied.promo : null,
    };
}

export function fmtRub(rub) {
    return rub.toLocaleString('ru-RU', { maximumFractionDigits: 2 });
}